// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Organization Content — matches Content Approvals / dashboard layout styles.
   Child pages need their own .submission-field offset (Angular encapsulation). */
/* Dashboard shell layout — required so content is not under the left menu */
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}

.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important;
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0;
}

.dashbored-wrap {
  padding-left: 0px;
  margin-top: 0;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0;
  width: 100%;
  left: 0;
}

/* Summary cards (same as content-approvals) */
.com-record {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
  border: none !important;
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}

.followers-tag .box {
  width: auto;
  min-width: 180px;
  padding: 5px 16px 5px 10px;
  background: var(--fc-bg, #fff);
  border: 1px solid var(--fc-border, #ddd);
  border-radius: 10px;
  display: flex;
  align-items: center;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.16);
  gap: 12px;
}

.followers-tag .box .ico-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.followers-tag .box .card-icon {
  font-size: 20px;
  color: #5ea1d8;
}

.followers-tag .box .text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.followers-tag .box .text .count {
  background: transparent !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
}

.followers-tag .box .text .count b {
  font-size: 24px;
  font-weight: 700 !important;
  color: var(--fc-fg, #333);
  display: block;
  line-height: 1.2;
}

.followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: var(--fc-fg-muted, #666);
  line-height: 1.2;
}

/* Content grid */
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
}

.video-card {
  cursor: pointer;
  background: var(--fc-bg, #fff);
  border: 1px solid var(--fc-border, #e0e0e0);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.video-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.org-library-thumb {
  position: relative;
  aspect-ratio: 16/9;
  background: var(--fc-bg2, #e8eef4);
  overflow: hidden;
}
.org-library-thumb .thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.org-library-thumb__placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5ea1d8;
}
.org-library-thumb__placeholder mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
}

.type-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: rgba(94, 161, 216, 0.95);
}
.type-badge--pack {
  background: rgba(152, 92, 225, 0.95);
}
.type-badge__icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.video-info {
  padding: 12px 14px 14px;
}

.video-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--fc-fg, #212529);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 39px;
}

.channel-meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
}

.channel-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.video-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.video-avatar .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.channel-name {
  margin: 0;
  font-size: 13px;
  color: var(--fc-fg-muted, #555);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.org-library-unique-id {
  font-size: 12px;
  color: var(--fc-fg-muted, #777);
  flex-shrink: 0;
}

/* Loading skeleton */
.skeleton-card {
  cursor: default;
}
.skeleton-card:hover {
  transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.skeleton-text {
  background: linear-gradient(90deg, var(--fc-skel, #e9ecef) 25%, var(--fc-skel-wave, #dee2e6) 50%, var(--fc-skel, #e9ecef) 75%);
  background-size: 200% 100%;
  animation: org-content-shimmer 1.4s infinite;
}

.skeleton-line {
  height: 14px;
  margin: 0 0 8px;
  border-radius: 4px;
}
.skeleton-line--short {
  width: 55%;
}

@keyframes org-content-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/* Empty / error state */
.org-content-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 16px;
  text-align: center;
  border: 1px dashed var(--fc-border, #e0e0e0);
  border-radius: 10px;
  color: var(--fc-fg-muted, #666);
}
.org-content-state mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  color: #5ea1d8;
}
.org-content-state p {
  margin: 0;
  font-size: 14px;
}
.org-content-state--error, .org-content-state--error mat-icon {
  color: #c62828;
}

@media (max-width: 767px) {
  .scroll-div {
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .dashbored-wrap .table-wrap {
    padding: 0 0 20px;
  }
  .com-record {
    padding: 12px 16px 20px;
  }
  .followers-tag {
    gap: 12px;
  }
  .followers-tag .box {
    width: 100%;
    margin: 0;
    border-radius: 8px;
  }
  .video-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 0 16px;
  }
  .org-content-state {
    margin: 0 16px;
  }
}
@media (max-width: 420px) {
  .video-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/org-content/org-content.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;iFAAA;AAGA,4EAAA;AACA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AACF;AACE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iCAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAAF;AAEE;EACE,oBAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,aAAA;AADF;AAGE;EACE,yBAAA;EACA,WAAA;EACA,OAAA;AADJ;;AAKA,8CAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,8BAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,SAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAFF;;AAKA;EACE,kCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,SAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;AAFF;;AAKA,iBAAA;AACA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAFF;;AAKA;EACE,eAAA;EACA,8BAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,uDAAA;AAFF;AAIE;EACE,2BAAA;EACA,yCAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;AAHF;AAKE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAJF;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AALF;AAOE;EACE,oCAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AANJ;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,SAAA;EACA,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARF;;AAWA;EACE,eAAA;EACA,+BAAA;EACA,cAAA;AARF;;AAWA,qBAAA;AACA;EACE,eAAA;AARF;AAUE;EACE,eAAA;EACA,yCAAA;AARJ;;AAYA;EACE,8HAAA;EAMA,0BAAA;EACA,4CAAA;AAdF;;AAiBA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAdF;AAgBE;EACE,UAAA;AAdJ;;AAkBA;EACE;IACE,2BAAA;EAfF;EAiBA;IACE,4BAAA;EAfF;AACF;AAkBA,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,mBAAA;EACA,+BAAA;AAhBF;AAkBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,SAAA;EACA,eAAA;AAjBJ;AAoBE;EAEE,cAAA;AAnBJ;;AAuBA;EACE;IACE,qBAAA;IACA,oBAAA;IACA,iBAAA;EApBF;EAuBA;IACE,WAAA;IACA,SAAA;EArBF;EAwBA;IACE,2BAAA;EAtBF;EAyBA;IACE,iBAAA;EAvBF;EA0BA;IACE,uBAAA;EAxBF;EA2BA;IACE,SAAA;EAzBF;EA4BA;IACE,WAAA;IACA,SAAA;IACA,kBAAA;EA1BF;EA6BA;IACE,8BAAA;IACA,SAAA;IACA,eAAA;EA3BF;EA8BA;IACE,cAAA;EA5BF;AACF;AA+BA;EACE;IACE,0BAAA;EA7BF;AACF","sourcesContent":["/* Organization Content — matches Content Approvals / dashboard layout styles.\n   Child pages need their own .submission-field offset (Angular encapsulation). */\n\n/* Dashboard shell layout — required so content is not under the left menu */\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n}\n\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important;\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n\n  .dash-text {\n    padding: 10px 15px 0;\n  }\n}\n\n.dashbored-wrap {\n  padding-left: 0px;\n  margin-top: 0;\n\n  .table-wrap {\n    padding: 30px 30px 30px 0;\n    width: 100%;\n    left: 0;\n  }\n}\n\n/* Summary cards (same as content-approvals) */\n.com-record {\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  border: none !important;\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.followers-tag .box {\n  width: auto;\n  min-width: 180px;\n  padding: 5px 16px 5px 10px;\n  background: var(--fc-bg, #fff);\n  border: 1px solid var(--fc-border, #ddd);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.16);\n  gap: 12px;\n}\n\n.followers-tag .box .ico-box {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.followers-tag .box .card-icon {\n  font-size: 20px;\n  color: #5ea1d8;\n}\n\n.followers-tag .box .text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n}\n\n.followers-tag .box .text .count {\n  background: transparent !important;\n  box-shadow: none !important;\n  display: flex;\n  align-items: center;\n}\n\n.followers-tag .box .text .count b {\n  font-size: 24px;\n  font-weight: 700 !important;\n  color: var(--fc-fg, #333);\n  display: block;\n  line-height: 1.2;\n}\n\n.followers-tag .box .text p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fc-fg-muted, #666);\n  line-height: 1.2;\n}\n\n/* Content grid */\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 20px;\n}\n\n.video-card {\n  cursor: pointer;\n  background: var(--fc-bg, #fff);\n  border: 1px solid var(--fc-border, #e0e0e0);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.org-library-thumb {\n  position: relative;\n  aspect-ratio: 16 / 9;\n  background: var(--fc-bg2, #e8eef4);\n  overflow: hidden;\n\n  .thumbnail-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.org-library-thumb__placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #5ea1d8;\n\n  mat-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.type-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  background: rgba(94, 161, 216, 0.95);\n\n  &--pack {\n    background: rgba(152, 92, 225, 0.95);\n  }\n\n  &__icon {\n    width: 16px;\n    height: 16px;\n    object-fit: contain;\n    filter: brightness(0) invert(1);\n  }\n}\n\n.video-info {\n  padding: 12px 14px 14px;\n}\n\n.video-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--fc-fg, #212529);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: calc(15px * 1.3 * 2);\n}\n\n.channel-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.channel-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.video-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n\n  .avatar-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.channel-name {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fc-fg-muted, #555);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.org-library-unique-id {\n  font-size: 12px;\n  color: var(--fc-fg-muted, #777);\n  flex-shrink: 0;\n}\n\n/* Loading skeleton */\n.skeleton-card {\n  cursor: default;\n\n  &:hover {\n    transform: none;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  }\n}\n\n.skeleton-text {\n  background: linear-gradient(\n    90deg,\n    var(--fc-skel, #e9ecef) 25%,\n    var(--fc-skel-wave, #dee2e6) 50%,\n    var(--fc-skel, #e9ecef) 75%\n  );\n  background-size: 200% 100%;\n  animation: org-content-shimmer 1.4s infinite;\n}\n\n.skeleton-line {\n  height: 14px;\n  margin: 0 0 8px;\n  border-radius: 4px;\n\n  &--short {\n    width: 55%;\n  }\n}\n\n@keyframes org-content-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Empty / error state */\n.org-content-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 16px;\n  text-align: center;\n  border: 1px dashed var(--fc-border, #e0e0e0);\n  border-radius: 10px;\n  color: var(--fc-fg-muted, #666);\n\n  mat-icon {\n    font-size: 36px;\n    width: 36px;\n    height: 36px;\n    color: #5ea1d8;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n\n  &--error,\n  &--error mat-icon {\n    color: #c62828;\n  }\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n\n  .dashbored-wrap .table-wrap {\n    padding: 0 0 20px;\n  }\n\n  .com-record {\n    padding: 12px 16px 20px;\n  }\n\n  .followers-tag {\n    gap: 12px;\n  }\n\n  .followers-tag .box {\n    width: 100%;\n    margin: 0;\n    border-radius: 8px;\n  }\n\n  .video-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    padding: 0 16px;\n  }\n\n  .org-content-state {\n    margin: 0 16px;\n  }\n}\n\n@media (max-width: 420px) {\n  .video-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
